import { Box, Grid, Paper } from "@mui/material";
import { mainBg } from "../../config/constants";

import { useState } from "react";
import { useSelector } from "react-redux";
import ResetPasswordLastStep from "./ResetPasswordLastStep";
import SendRequestStep from "./SendRequestStep";
import VerifyCodeStep from "./VerfiyCodeStep";

export default function ResetPassword() {
  const logoIcon = useSelector((s) => s.app.logo);

  const [step, setStep] = useState("send_request");
  const [data, setData] = useState({ mobile: "", code: "" });
  const getMobile = (mobile) => {
    setData({ ...data, mobile });
    setStep("verify_code");
  };

  const verifyCode = (code) => {
    setData({ ...data, code });
    setStep("reset_password");
  };
  return (
    <Grid
      container
      sx={{
        height: 1,
        backgroundImage: `url(${mainBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100dvh",
      }}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      alignContent="center"
    >
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        alignContent="start"
        container
        justifyContent="start"
        textAlign="start"
      >
        <Grid
          item
          justifyContent="start"
          alignSelf="start"
          justifySelf="start"
          textAlign="start"
          sx={{ display: { xs: "none", sm: "none", md: "block" }, ml: 10 }}
        >
          <img
            loading="lazy"
            src={"/images/layout/logo.png"}
            height={100}
            alt=""
          />
        </Grid>
      </Grid>
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        sx={{ px: { md: 5, xs: 1, sm: 1 }, height: 1 }}
        alignContent="center"
        container
      >
        <Grid
          item
          sm={12}
          xs={12}
          sx={{ height: { lg: "65%", md: "80%", sm: "80%" } }}
        >
          <Paper
            elevation={1}
            sx={{
              px: 3,
              pt: 2,
              pb: 4,
              textAlign: "center",
              alignSelf: "center",
              width: "100%",
              maxWidth: "712px",
              borderRadius: "24px",
              backgroundColor: "background.authBg",
            }}
          >
            <img src={logoIcon} alt="pyxiz" height={72} />
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              justifyContent="space-between"
              height={1}
              width={1}
            >
              {step === "send_request" && (
                <SendRequestStep onSubmit={getMobile} />
              )}
              {step === "verify_code" && (
                <VerifyCodeStep
                  onSubmit={verifyCode}
                  mobile={data.mobile}
                  setStep={setStep}
                />
              )}
              {step === "reset_password" && (
                <ResetPasswordLastStep
                  mobile={data.mobile}
                  code={data.code}
                  setStep={setStep}
                />
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
}
